import { BuildingType } from "shared/types/references/BuildingType"

import z from "zod"

export const buildingReferenceFilterFormDataSchema = z.object({
  searchTerm: z.string().optional().nullable(),
  products: z.array(z.string()).optional().nullable(),
  buildingTypes: z.array(z.enum(BuildingType)).optional().nullable()
})

export type BuildingReferenceFilterFormData = z.infer<
  typeof buildingReferenceFilterFormDataSchema
>
